import type { TrackData } from '@/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getLlmModelHeader, LLM_FUNCTION_ID } from '@eureka/utils/llm-model';

export const TrackApiService = Symbol('TrackApiService');

export interface TrackApiService {
    track(dataTrack: TrackData): Promise<boolean>;
}

@injectable()
export class TrackApiServiceImpl extends PsHttpService implements TrackApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
                ...getLlmModelHeader(LLM_FUNCTION_ID.QUICK_RESEARCH),
            },
        };
    }

    track(dataTrack: TrackData) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/tracking/add',
            data: {
                ...dataTrack,
                module_type: 'EUREKA',
            },
        }).then((res) => {
            return res.status as boolean
        })
    }
}
